import React, { useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import rateCodeService from '../services/rateCodeService';
import corporateProfileService from '../services/corporateProfileService';
import OhipLovPicker from './OhipAgentTypePicker';
import OhipProfilePicker from './OhipProfilePicker';
import './AddCorporateProfilePage.css';

const EMPTY_FORM = {
    rateCode: '',
    rateCodeName: '',
};

const AddRateCodePage = () => {
    const navigate = useNavigate();
    const { ppId } = useParams();
    const [searchParams] = useSearchParams();
    const ruleId = searchParams.get('ruleId');
    const [form, setForm] = useState(EMPTY_FORM);
    const [errors, setErrors] = useState({});
    const [saving, setSaving] = useState(false);

    const set = (field, value) => {
        setForm(f => ({ ...f, [field]: value }));
        setErrors(e => ({ ...e, [field]: undefined }));
    };

    const validate = () => {
        const e = {};
        if (!form.rateCode.trim()) e.rateCode = 'Rate Code is required';
        if (!form.rateCodeName.trim()) e.rateCodeName = 'Rate Code Name is required';
        return e;
    };

    const handleCreate = async () => {
        const e = validate();
        if (Object.keys(e).length) { setErrors(e); return; }
        setSaving(true);
        try {
            await rateCodeService.create(ppId, {
                rate_code:      form.rateCode,
                rate_code_name: form.rateCodeName,
                active:         true,
            }, ruleId);
            navigate(ruleId ? `/apps/payment-porter/${ppId}/rules/${ruleId}` : `/apps/payment-porter/${ppId}`);
        } catch (err) {
            setErrors({ submit: err.response?.data?.error?.message || 'Failed to save rate code' });
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="acp-page">
            <div className="acp-card">
                <div className="acp-card-header">
                    <h1 className="acp-title">Add Rate Code</h1>
                </div>

                <div className="acp-divider" />

                <div className="acp-body">
                    <div className="acp-field">
                        <label className="acp-label">Rate Code <span className="acp-required">*</span></label>
                        <input
                            className={`acp-input${errors.rateCode ? ' acp-input-error' : ''}`}
                            type="text"
                            placeholder="e.g., CORP, GOV, PKG"
                            value={form.rateCode}
                            onChange={e => set('rateCode', e.target.value)}
                            autoFocus
                        />
                        {errors.rateCode && <span className="acp-error-msg">{errors.rateCode}</span>}
                    </div>

                    <div className="acp-field">
                        <label className="acp-label">Rate Code Name <span className="acp-required">*</span></label>
                        <input
                            className={`acp-input${errors.rateCodeName ? ' acp-input-error' : ''}`}
                            type="text"
                            placeholder="e.g., Corporate Rate, Government Rate"
                            value={form.rateCodeName}
                            onChange={e => set('rateCodeName', e.target.value)}
                        />
                        {errors.rateCodeName && <span className="acp-error-msg">{errors.rateCodeName}</span>}
                    </div>

                </div>

                {errors.submit && <div className="acp-error-msg" style={{ margin: '0 0 1rem' }}>{errors.submit}</div>}
                <div className="acp-footer">
                    <button
                        className="acp-btn-cancel"
                        onClick={() => navigate(`/apps/payment-porter/${ppId}`)}
                        disabled={saving}
                    >
                        Cancel
                    </button>
                    <button
                        className="acp-btn-create"
                        onClick={handleCreate}
                        disabled={saving}
                    >
                        {saving ? 'Creating...' : 'Create'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddRateCodePage;
